<template>
    <v-dialog v-model="dialoge" absolute scrollable max-width="700" @input="$emit('update:show_dialoge', false)">
        <v-card>
            <v-card-title class="headline">
                <v-icon left>{{ product.icon }}</v-icon>
                <span class="text-truncate"><span class="hidden-sm-and-down">Fragen zur Angebotserstellung:</span> {{ product.name }}</span>
            </v-card-title>
            <v-card-text>
                <p>Um Ihr individuelles und unverbindliches Angebot zu erstellen, bitte folgende Risikoangaben ausfüllen.</p>
                <v-form ref="productquestion_form" lazy-validation @submit.prevent="getNextStep()">
                    <v-stepper v-model="productquestion_act_step" vertical>
                        <template v-for="(group, group_index) in product_questions">
                            <v-stepper-step :step="group_index+1" :complete="productquestion_act_step > group_index+1" :editable="productquestion_act_step > group_index+1" :key="`${group_index}-step`">
                                {{ _.isEmpty(group.label) ? group.label_short : group.label }}
                                <small v-if="!_.isEmpty(group.title)">{{ group.title }}</small>
                            </v-stepper-step>

                            <v-stepper-content :step="group_index+1" :key="`${group_index}-content`">
                                <fieldset>
                                    <!-- START ausnahme für risikofragengruppe=5  -->
                                    <div v-if="group.id==5">
                                        <v-text-field 
                                            :value="address_private.street ? `${address_private.street ? address_private.street : ''}${address_private.additional ? ', '+address_private.additional : ''}, ${address_private.zipcode ? address_private.zipcode : ''} ${address_private.city ? address_private.city : ''}${address_private.countrycode ? ', '+address_private.countrycode : ''}` : ``" 
                                            label="Ihre Privatanschrift (aus „Meine Daten‟)"
                                            @click="show_form_privateaddress = true"
                                        />
                                        <v-bottom-sheet v-model="show_form_privateaddress" inset>
                                            <v-card class="pa-3" tile>
                                                <v-form ref="form_privateaddress" lazy-validation @submit.prevent="submit('form_privateaddress')">
                                                    <v-layout row wrap justify-center>
                                                        <v-flex xs12 md6 pr-2>
                                                            <v-text-field
                                                                v-model="address_private.street"
                                                                name="street"
                                                                label="Straße + Hausnummer"
                                                                hint="oder ggf. Postfachnummer"
                                                                maxlength="60"
                                                                clearable
                                                                autocomplete="address-line1"
                                                            />
                                                        </v-flex>
                                                        <v-flex xs12 md6 pl-2>
                                                            <v-text-field
                                                                v-model="address_private.additional"
                                                                label="C/O, Adresszusatz"
                                                                maxlength="36"
                                                                clearable
                                                                autocomplete="address-line2"
                                                            />
                                                        </v-flex>
                                                        <v-flex xs12 md6 pr-2>
                                                            <v-layout justify-center>
                                                                <v-flex xs12 md6 pr-2>
                                                                    <v-text-field
                                                                        type="number"
                                                                        v-model="address_private.zipcode"
                                                                        name="zipcode"
                                                                        label="PLZ"
                                                                        hint="(Postleitzahl)"
                                                                        min="1000"
                                                                        max="99998"
                                                                        autocomplete="postal-code"
                                                                    />
                                                                </v-flex>
                                                                <v-flex xs12 md6 pl-2>
                                                                    <v-text-field
                                                                        v-model="address_private.city"
                                                                        name="city"
                                                                        label="Ort"
                                                                        hint="Ort oder Stadt der PLZ"
                                                                        maxlength="60"
                                                                        clearable
                                                                        autocomplete="address-level1"
                                                                    />
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 md6 pl-2>
                                                            <v-autocomplete
                                                                :items="countryoptions"
                                                                v-model="address_private.countrycode"
                                                                name="countrycode"
                                                                open-on-clear
                                                                label="Land"
                                                                maxlength="2"
                                                                clearable
                                                                autocomplete="country"
                                                            />
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-card-actions class="pa-0">
                                                        <v-btn flat color="secondary" @click="show_form_privateaddress = false">Abbrechen</v-btn>
                                                        <v-spacer />
                                                        <v-btn color="black" dark @click="setPrivateAddress()">Speichern</v-btn>
                                                    </v-card-actions>
                                                </v-form>
                                            </v-card>
                                        </v-bottom-sheet>
                                    </div>
                                    <!-- END ausnahme für risikofragengruppe=5  -->

                                    <template v-for="question in group.questions">
                                        <div v-if="question.type=='checkbox'" :key="`${question.id}-checkbox`">
                                            <p :title="/\r|\n/.exec(question.title) ? '' : question.title">{{ question.label }}</p>
                                            <v-checkbox 
                                                v-for="(option, index) in questionitems[`q_${question.id}`]" 
                                                :key="`${index}-${question.id}-option`"
                                                v-model="answers[`q_${question.id}`]"
                                                :name="`q_${question.id}[]`"
                                                :ref="`q_${question.id}`"
                                                :label="option.text"
                                                :hint="question.placeholder"
                                                persistent-hint
                                                :value="option.value"
                                                :rules="getRules(question)"
                                                :required="question.is_required=='1'"
                                                color="black"
                                                :error="questionerrors[`q_${question.id}`]"
                                            >
                                                <template v-if="/\r|\n/.exec(question.title)" v-slot:label>
                                                    <div> {{ option.text }}
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on }">
                                                                <v-icon v-on="on" color="info">help_outline</v-icon>
                                                            </template>
                                                            {{ option.title }}
                                                        </v-tooltip>
                                                    </div>
                                                </template>
                                            </v-checkbox>
                                        </div>
                                        <div v-else-if="question.type=='radio'" :key="`${question.id}-radio`">
                                            <p :title="question.title">{{ question.label }}</p>
                                            <v-radio-group v-if="!question.required_products_questions_id || answers[`q_${question.required_products_questions_id}`]+''==question.required_products_questions_value" v-model="answers[`q_${question.id}`]" :name="`q_${question.id}`" :ref="`q_${question.id}`" column>
                                                <v-radio
                                                    v-for="(option, index) in questionitems[`q_${question.id}`]" 
                                                    :key="`${index}-${question.id}-option`"
                                                    :label="option.text"
                                                    :hint="question.placeholder"
                                                    persistent-hint
                                                    :value="option.value"
                                                    :rules="getRules(question)"
                                                    :required="question.is_required=='1'"
                                                    color="black"
                                                    :error="questionerrors[`q_${question.id}`]"
                                                ></v-radio>
                                            </v-radio-group>
                                        </div>
                                        <div v-else-if="question.type=='switch'" :key="`${question.id}-switch`">
                                            <v-switch 
                                                v-if="!question.required_products_questions_id || answers[`q_${question.required_products_questions_id}`]+''==question.required_products_questions_value"
                                                v-model="answers[`q_${question.id}`]"
                                                :name="`q_${question.id}`"
                                                :ref="`q_${question.id}`"
                                                :label="question.label"
                                                :hint="question.placeholder"
                                                persistent-hint
                                                :title="question.title"
                                                :rules="getRules(question)"
                                                :required="question.is_required=='1'"
                                                color="black"
                                                :error="questionerrors[`q_${question.id}`]"
                                            ></v-switch>
                                        </div>
                                        <div v-else-if="question.type=='select'" :key="`${question.id}-select`">
                                            <v-select
                                                v-if="!question.required_products_questions_id || answers[`q_${question.required_products_questions_id}`]+''==question.required_products_questions_value"
                                                v-model="answers[`q_${question.id}`]"
                                                :name="`q_${question.id}`"
                                                :ref="`q_${question.id}`"
                                                :label="question.label"
                                                :hint="question.placeholder"
                                                persistent-hint
                                                :title="question.title=='' ? question.label : question.title"
                                                :items="questionitems[`q_${question.id}`]"
                                                :rules="getRules(question)"
                                                :required="question.is_required=='1'"
                                                color="black"
                                                :error="questionerrors[`q_${question.id}`]"
                                            ></v-select>
                                        </div>
                                        <div v-else-if="question.type=='autocomplete'" :key="`${question.id}-autocomplete`">
                                            <v-autocomplete
                                                v-if="!question.required_products_questions_id || answers[`q_${question.required_products_questions_id}`]+''==question.required_products_questions_value"
                                                v-model="answers[`q_${question.id}`]"
                                                :name="`q_${question.id}`"
                                                :ref="`q_${question.id}`"
                                                :label="question.label"
                                                :hint="question.placeholder"
                                                persistent-hint
                                                :title="question.title"
                                                :items="questionitems[`q_${question.id}`]"
                                                :rules="getRules(question)"
                                                :required="question.is_required=='1'"
                                                item-value="text"
                                                color="black"
                                                :error="questionerrors[`q_${question.id}`]"
                                            ></v-autocomplete>
                                        </div>
                                        <div v-else :key="`${question.id}-question`">
                                            <v-text-field
                                                v-if="!question.required_products_questions_id || answers[`q_${question.required_products_questions_id}`]+''==question.required_products_questions_value"
                                                v-model="answers[`q_${question.id}`]"
                                                :name="`q_${question.id}`"
                                                :ref="`q_${question.id}`"
                                                :label="question.label"
                                                :rules="getRules(question)"
                                                :required="question.is_required=='1'"
                                                :type="question.type ? question.type : 'text'"
                                                :hint="question.placeholder ? question.placeholder : ''"
                                                persistent-hint
                                                :title="question.title"
                                                :mexlength="question.mexlength"
                                                color="black"
                                                :error="questionerrors[`q_${question.id}`]"
                                            ></v-text-field>
                                        </div>
                                    </template>
                                </fieldset>
                                <footer class="d-flex">
                                    <v-btn v-if="group_index==0" flat @click="$emit('update:show_dialoge', false)">Abbrechen</v-btn>
                                    <v-btn v-else flat @click="productquestion_act_step--">Zurück</v-btn>
                                    <v-spacer />
                                    <v-btn color="black" dark @click="getNextStep()">{{ product_questions[group_index+1] ? `Nächster Schritt` : `Tarifvergleich erhalten` }}</v-btn>
                                </footer>
                            </v-stepper-content>
                        </template>
                    </v-stepper>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>


<script>
import { COUNTRY_OPTIONS } from '@/constants.js'


export default {
    name: 'ProductQuestionsModal',

    data() {
        return {
            dialoge: false,
            productquestion_act_step: -1,
            step_has_error: false,
            answers: {},
            questionitems: {},
            questionerrors: {},
            rules: {
                required: value => !!value || 'Pflichtfeld - Bitte ausfüllen',
                email: v => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(v) || 'Bitte eine gültige E-Mail-Adresse eingeben'
                }
            },

            // address_private: {},
            show_form_privateaddress: false
        }
    },


    props: {
        product_questions: {
            type: Array
        },
        product: {
            type: Object,
            default: () => ({ 
                id: 0, 
                name: 'Eigenes Produkt', 
                icon: 'star' 
            })
        },
        show_dialoge: {
            type: Boolean,
            default: false
        }
    },


    computed: {
        countryoptions(){
            return COUNTRY_OPTIONS;
        },
        address_private(){
            return {...this.$store.getters['addresses/getAddressesByType']('private')[0]};
        }
    },


    watch: { 
      	show_dialoge: function(val) { 
            //   console.log('show_dialoge :>> ', val);
            this.productquestion_act_step = 1;
            this.dialoge = val;
        },
        product_questions: function(product_questions, oldVal) {
            // console.log('questions changed: ', newVal, ' | was: ', oldVal);
            let answers = {};
            let questionerrors = {};
            let questionitems = {};
            product_questions.forEach(group => {
                group.questions.forEach(question => {
                    questionerrors[`q_${question.id}`] = false;
                    if(question.type=='checkbox'){
                        if(_.isEmpty(question.value)){
                            answers[`q_${question.id}`] = [];
                        }else{
                            answers[`q_${question.id}`] = question.value.split(',');
                        }
                    }else{
                        if(question.type=='switch'){
                            if(_.isEmpty(question.value)){
                                answers[`q_${question.id}`] = false;
                            }else{
                                answers[`q_${question.id}`] = question.value=='true';
                            }
                        }else{
                            if(_.isEmpty(question.value)){
                                answers[`q_${question.id}`] = null;
                            }else{
                                answers[`q_${question.id}`] = question.value;
                            }
                        }
                    }
                    if(_.isEmpty(question.options)){
                        questionitems[`q_${question.id}`] = null;
                    }else{
                        if(question.type=='autocomplete'){
                            // console.log('datalist :>> ', question.options);
                            if(question.options=='productpartners'){
                                let tmp = this.$store.getters['products/getAllCompanies'];
                                if(tmp.length<5){
                                    this.$store.dispatch('products/loadProductpartnerData').then(companies => {
                                        questionitems[`q_${question.id}`] = this.$store.getters['products/getAllCompaniesAsItemlist4CompanyInsurances'];
                                    });
                                }else{
                                    questionitems[`q_${question.id}`] = this.$store.getters['products/getAllCompaniesAsItemlist4CompanyInsurances'];
                                }
                            }
                        }else{
                            questionitems[`q_${question.id}`] = [];
                            let options = question.options.split(/\r?\n/);
                            options.forEach((option, index) => {
                                questionitems[`q_${question.id}`].push({
                                    text: option.split('|')[0],
                                    value: option.split('|')[1],
                                    title: /\r|\n/.exec(question.title) ? question.title.split(/\r?\n/)[index] : ''
                                });
                            });
                        }
                    }
                })
            })
            this.answers = answers;
            this.questionerrors = questionerrors;
            this.questionitems = questionitems;
        },
    },


    methods: {
        getNextStep(){
            if(this.product_questions[this.productquestion_act_step]){
                this.step_has_error = false;
                this.product_questions[this.productquestion_act_step-1].questions.forEach(question => {
                    if(this.$refs['q_'+question.id]){
                        // console.log('checkValidity :>> ', this.$refs['q_'+question.id][0].validate() );
                        if(!this.$refs['q_'+question.id][0].validate()){
                            if(!this.step_has_error && (question.type!='switch')){
                                this.$refs['q_'+question.id][0].focus();
                            }
                            this.step_has_error = true;
                            this.questionerrors[`q_${question.id}`] = true;
                        }else{
                            this.questionerrors[`q_${question.id}`] = false;
                        }
                    }
                });
                if(!this.step_has_error){
                    this.productquestion_act_step++;
                }
            }else{
                this.$emit('questionsAnswered', this.answers);
            }
        },

        setPrivateAddress(){
            this.address_private.type = 'private'; 
             if(_.isEmpty(this.address_private.countrycode)){ 
                this.address_private.countrycode = 'DE'; 
            };
            this.$store.dispatch(`addresses/${this.address_private.id ? 'set' : 'add'}Address`, this.address_private);

            const init = this.$store.getters['addresses/getAddressesByType']('private');
            let con = `Die Privatadresse wurde von "${init.street ? init.street : ''}, ${init.additional ? init.additional : ''}, ${init.zipcode ? init.zipcode : ''} ${init.city ? init.city : ''}, ${init.countrycode ? init.countrycode : ''}" in "${this.address_private.street ? this.address_private.street : ''}, ${this.address_private.additional ? this.address_private.additional : ''}, ${this.address_private.zipcode ? this.address_private.zipcode : ''} ${this.address_private.city ? this.address_private.city : ''}, ${this.address_private.countrycode ? this.address_private.countrycode : ''}" umgeändert.`;
            this.$store.dispatch('chat/addUserChatMessage', {title:'Einstellungen geändert', content:con, type: 'settings'});
            this.$snotify.success('Gespeichert');
            this.show_form_privateaddress = false;
        },

        getRules(question){
            let rules = [];
            if(question.is_required=='1'){
                rules.push(this.rules.required);
            }
            if(question.pattern && !_.isEmpty(question.pattern)){
                rules.push(v => question.pattern.test(v) || 'Bitte geben Sie gültige Werte ein.');
            }
            return rules;
        }
    }
}
</script>


<style scoped>
.v-stepper {
	background: none;
	border: none;
	box-shadow: none;
	padding: 0;
}
.v-stepper__wrapper fieldset {
    border:none;
    padding-left: 15px;
}
.v-stepper__wrapper fieldset > div {
    padding-bottom: 15px;
}


@media screen and (max-width: 768px) {
    .v-stepper__wrapper fieldset {
        padding-left: 0;
    }
    .v-stepper__wrapper footer.d-flex {
        flex-direction: column;
    }
    .v-stepper--vertical .v-stepper__step {
        padding: 15px 5px 15px;
    }
    .v-stepper--vertical .v-stepper__content {
        margin-left: 16px;
        padding-left: 16px;
    }
}
</style>